import type { SVGProps } from 'react';

const SvgNoticeOffMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M7.1129 7.79194V18.3585C7.1129 19.2663 7.92168 20.0022 8.91935 20.0022C9.91703 20.0022 10.7258 19.2663 10.7258 18.3585V15.8315M6.3399 14.2162L15.6609 18.0173C17.0181 18.5172 18.5 17.6083 18.5 16.2761V5.88258C18.5 4.55032 17.0181 3.64145 15.6609 4.14131L6.3399 7.94245C4.93536 8.45973 3.5 9.16808 3.5 11.2052C3.5 12.9251 4.93536 13.6989 6.3399 14.2162Z'
      stroke='currentColor'
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgNoticeOffMd;
